import MainLayout from '../layouts/main';
import HomeworksContainer from './container';

function HomeworksPage() {
  return (
    <MainLayout>
      <HomeworksContainer/>
    </MainLayout>
  );
}

export default HomeworksPage;
